import React, { useContext } from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { formDesignProps } from '../../form_fields/ctrl_proptype';
import { FormContext } from '../../shared/contexts/form-context';

const getAlignmentId = (alignment) => {
  if (alignment === 'left floated' || alignment === 'ltr') return 'left';
  if (alignment === 'right floated' || alignment === 'rtl') return 'right';
  return 'centered';
};

const FormFooter = ({ formDesign }) => {
  const { inCustomise, inForm } = useContext(FormContext);

  const footerStyles = {
    // '--footer-padding': `${formDesign.design.footer_padding}px ${formDesign.design.footer_padding}px ${formDesign.design.footer_padding / 2
    //   }px`,
    '--footer-padding': `0px ${formDesign.design.footer_padding / 2
      }px`,
  };

  const isLogoHere = formDesign.old.custom_logo_image && formDesign.design.logo_placement === 'footer';
  const alignmentId = isLogoHere ? getAlignmentId(formDesign.old.custom_logo_alignment) : undefined;
  const customLogo = formDesign.old.custom_logo_image;

  if (!(inCustomise || inForm)) return null;

  return (
    <Wrapper style={footerStyles}>
      {isLogoHere && (
        <Logo id={alignmentId}>
          <div>
            <img src={customLogo} alt="Custom Logo" />
          </div>
        </Logo>
      )}
    </Wrapper>
  );
};

FormFooter.propTypes = {
  formDesign: PropTypes.shape(formDesignProps).isRequired,
};

export default FormFooter;

const Wrapper = styled.div`
  padding: var(--footer-padding);
  direction: initial;
`;

const Logo = styled.div`
  ${tw`flex`};

  &#left {
    ${tw`justify-start`};
  }

  &#right {
    ${tw`justify-end`};
  }

  &#centered {
    ${tw`justify-center`};
  }

  img {
    ${tw`relative block max-w-full bg-transparent max-h-24`};
  }
`;
